import { useState, useEffect, useRef } from "react";
import "../../css/Panel.css";
import "../../css/Patient.css";
import "../../css/PatientSearch.css";
import "../../css/custom-datatable.css";
import "../css/Calendar.css";
import "../css/PopupMessage.css";

import CalendarItem from "../components/CalendarItem";
import CalendarMCellTitle from "../components/CalendarMCellTitle";
import CalendarMRow from "../components/CalendarMRow";
import CalendarWCellTitle from "../components/CalendarWCellTitle";
import CalendarWCellTitleSeparator from "../components/CalendarWCellTitleSeparator";
import CalendarWRow from "../components/CalendarWRow";
import CalendarDRow from "../components/CalendarDRow";
import CalendarColorSelector from "../components/CalendarColorSelector";
import CalendarPeopleOption from "../components/CalendarPeopleOption";
import PopupTitle from "../components/PopupTitle";
import PopupEvent from "../components/PopupEvent";
import ButtonIconHToday from "../components/ButtonIconHToday";
import SlotEventCard from "../components/SlotEventCard";
import SlotEventCardSimple from "../components/SlotEventCardSimple";
import CalendarARow from "../components/CalendarARow";
import PopupEventsPatientList from "../components/PopupEventsPatientList";

import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import CheckBox from "../../components/CheckBox";
import InputData from "../../components/InputData";
import InputSearch from "../../components/InputSearch";
import TooltipBox from "../../components/Tooltip";
import InputIconSearchPanelMultiSelection from "../../components/InputIconSearchPanelMultiSelection";

import {
  getToday,
  monthNumberToName,
  dayNumberToName,
  hourNumberToTime,
} from "../utils/utils";

import { CALENDAR_HOURS_COMPLETE, EVENT_STATUS } from "../js/constants";
import { post as rpost } from "../js/api";

import { userData, selectedOptic } from "../../js/utils";
import { post } from "../../js/post";

import { CALENDAR_TYPE_OPTIONS } from "../js/constants";

import moment from "moment";

export default function Calendar({
  show,
  onClickMenuOption,
  createPopupQuestion,
  removePopupQuestion,
  onGoBack,
}) {
  const [selectedCalendarType, setSelectedCalendarType] = useState(
    CALENDAR_TYPE_OPTIONS[0],
  );
  const [calendars, setCalendars] = useState([]);
  const [agents, setAgents] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [events, setEvents] = useState([]);
  const [today, setToday] = useState(getToday());
  const [selectedDate, setSelectedDate] = useState(moment());
  const [calendarEdit, setCalendarEdit] = useState(null);
  const [showWeekends, setShowWeekends] = useState(null);
  const [minTime, setMinTime] = useState(0);
  const [maxTime, setMaxTime] = useState(24);
  const [editEvent, setEditEvent] = useState(null);

  const [dayEvents, setDayEvents] = useState([]);
  const [rangeMinTime, setRangeMinTime] = useState({
    id: CALENDAR_HOURS_COMPLETE[10].id,
    text: CALENDAR_HOURS_COMPLETE[10].text,
  });
  const [rangeMaxTime, setRangeMaxTime] = useState({
    id: CALENDAR_HOURS_COMPLETE[20].id,
    text: CALENDAR_HOURS_COMPLETE[20].text,
  });
  const [listedEventsDate, setListedEventsDate] = useState([]);
  const [listedEventsDateDay, setListedEventsDateDay] = useState(null);
  const [showEventsPopup, setShowEventsPopup] = useState(false);
  const [eventsPopupPatient, setEventsPopupPatient] = useState(null);
  const [eventsPopupEventsPast, setEventsPopupEventsPast] = useState(null);
  const [eventsPopupEventsFuture, setEventsPopupEventsFuture] = useState(null);

  const fEventDivRef = useRef(null);
  const monthlyCalendarRef = useRef(null);
  const debounceTimerRef = useRef(null);
  const pendingLoadRef = useRef(null);
  const selectedDateRef = useRef(selectedDate);
  const calendarsRef = useRef(calendars);
  const animationTimeoutsRef = useRef([]);

  const CALLING_ENDPOINTS_TIME = 250;
  const FLASH_DAY_TIME = 750;

  const calculateMinMaxDate = (date, calendarType) => {
    let dateM = moment(date);
    const minMaxDates = {
      min: date.format("YYYY-MM-DD"),
      max: date.format("YYYY-MM-DD"),
    };
    switch (calendarType) {
      case "MENSUAL":
        dateM = moment(date);
        minMaxDates.min = dateM
          .startOf("month")
          .startOf("isoWeek")
          .format("YYYY-MM-DD");
        dateM = moment(date);
        minMaxDates.max = dateM
          .endOf("month")
          .endOf("isoWeek")
          .format("YYYY-MM-DD");
        const diff = moment(minMaxDates.max, "YYYY-MM-DD").diff(
          moment(minMaxDates.min, "YYYY-MM-DD"),
          "weeks",
        );
        if (diff === 4) {
          // Add an extra week to be consequent with the calendar UI
          minMaxDates.max = moment(minMaxDates.max, "YYYY-MM-DD")
            .add(7, "days")
            .format("YYYY-MM-DD");
        }
        break;
      case "SEMANAL":
        dateM = moment(date);
        minMaxDates.min = dateM.startOf("isoWeek").format("YYYY-MM-DD");
        dateM = moment(date);
        minMaxDates.max = dateM.endOf("isoWeek").format("YYYY-MM-DD");
        break;
    }

    return minMaxDates;
  };

  const calculateMinMaxTime = (calendars) => {
    let minT = -1;
    let maxT = -1;
    calendars.forEach((calendar) => {
      // Los calendarios de festivos solo tienen eventos de día completo
      if (calendar.visible && !calendar.festivo) {
        if (minT === -1) {
          minT = calendar.minTime;
          maxT = calendar.maxTime;
        } else {
          if (calendar.minTime < minT) {
            minT = calendar.minTime;
          }
          if (calendar.maxTime > maxT) {
            maxT = calendar.maxTime;
          }
        }
      }
    });
    if (minT === -1) {
      minT = 0;
      maxT = 24;
    }
    setMinTime(minT);
    setMaxTime(maxT);
  };

  const sortCalendars = (cals) => {
    // Users with writing permissions first

    cals.forEach((cal) => {
      if (cal.users.length > 1) {
        const usersW = cal.users.filter((user) => {
          return !user.readOnly;
        });
        const usersR = cal.users.filter((user) => {
          return user.readOnly;
        });
        cal.users = usersW.concat(usersR);
      }
    });

    cals.sort((a, b) => {
      if (!a.festivo && b.festivo) return -1;
      if (a.festivo && !b.festivo) return 1;
      return 0;
    });

    return cals;
  };

  const loadCalendars = async () => {
    const response = await rpost("agenda/ListarCalendarios.php", {
      token: userData.token,
      idUsuario: userData.id,
      idOptica: selectedOptic.id,
    });

    setShowWeekends(response.ajustes.mostrarFinesDeSemana);

    let cals = response.calendarios.map((cal) => {
      const c = {
        id: cal.id,
        name: cal.nombre,
        color: cal.color,
        visible: cal.visible,
        minTime: parseInt(cal.horaInicio.split(":")[0]),
        maxTime: parseInt(cal.horaFin.split(":")[0]),
        users: [],
        iCanEdit: false,
        festivo: cal.festivo,
      };
      c.users = cal.usuarios.map((user) => {
        return {
          id: user.id,
          name: user.nombre,
          lastName: user.apellidos,
          readOnly: user.soloLectura,
          pic: null,
        };
      });
      return c;
    });
    cals.forEach((cal) => {
      const user = cal.users.find((u) => {
        return u.id === userData.id;
      });
      if (user) {
        cal.iCanEdit = !user.readOnly;
      }
    });
    cals = sortCalendars(cals);

    for (let i = 0; i < cals.length; i++) {
      const cal = cals[i];
      for (let j = 0; j < cal.users.length; j++) {
        const us = cal.users[j];
        if (us.pic == null) {
          const response = await post("ObtenerFotoUsuario.php", {
            token: userData.token,
            idUsuario: us.id,
          });
          us.pic = response.foto;

          for (let k = i + 1; k < cals.length; k++) {
            const c = cals[k];
            for (let l = 0; l < c.users.length; l++) {
              const u = c.users[l];
              if (u.id === us.id) {
                u.pic = us.pic;
              }
            }
          }
        }
      }
    }

    setCalendars(cals);
    calculateMinMaxTime(cals);

    const minMaxDates = calculateMinMaxDate(
      selectedDate,
      selectedCalendarType.id,
    );
    await loadEvents(cals, minMaxDates.min, minMaxDates.max);
  };

  const loadAgents = async () => {
    const response = await rpost("fichas/ListarAgentes.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    setAgents(response);
    const agentListN = response.map((agent) => {
      return agent.nombreApellidos;
    });
    setAgentList(agentListN);
  };

  const sortEvents = (evs) => {
    // All day events first

    const evsAll = evs.filter((ev) => {
      return ev.timeStart === -1;
    });

    const evsNotAll = evs.filter((ev) => {
      return ev.timeStart !== -1;
    });

    // Sort not all day events by start time

    evsNotAll.sort((a, b) => {
      if (a.timeStart > b.timeStart) {
        return 1;
      }
      if (a.timeStart < b.timeStart) {
        return -1;
      }
      return 0;
    });

    return evsAll.concat(evsNotAll);
  };

  const createPeriodicEvent = (pEvent, date, calendarId, index) => {
    return {
      id: pEvent.id + "-" + index,
      title: pEvent.nombre,
      calendarId: calendarId,
      date: date,
      timeStart: pEvent.horaInicio,
      timeEnd: pEvent.horaFinal,
      patient: {
        id: pEvent.paciente.id === "" ? -1 : pEvent.paciente.id,
        name: pEvent.paciente.nombre,
        lastName: pEvent.paciente.apellidos,
        pic: null,
      },
      calendarColor: "black",
      visible: true,
      agent: pEvent.profesional,
      subject: pEvent.asunto,
      periodic: true,
      periodicId: pEvent.id,
      periodicity: pEvent.tipo,
      periodicityOnHolidays: pEvent.accionFestivo,
      periodicityEnd:
        pEvent.fechaFinRepeticion !== "" || pEvent.numRepeticiones !== -1,
      periodicityEndType:
        pEvent.fechaFinRepeticion === "" && pEvent.numRepeticiones !== -1
          ? "RepetirNumero"
          : "RepetirFecha",
      periodicityEndTypeDate: pEvent.fechaFinRepeticion,
      periodicityNumberRepetitions:
        pEvent.numRepeticiones === -1 ? "5" : pEvent.numRepeticiones.toString(),
      periodicityExceptionId: -1,
    };
  };

  const applyPeriodicExceptions = (pEvent, deployedEvents, exceptions) => {
    const exceptionsF = exceptions.filter((ex) => {
      return ex.idEventoPeriodico === pEvent.id;
    });
    exceptionsF.forEach((ex) => {
      const evs = deployedEvents.filter((e) => {
        let found = false;
        if (ex.aplicableSoloEsteEvento) {
          if (
            e.date === ex.fechaAntigua &&
            e.timeStart === ex.horaInicioAntigua &&
            e.timeEnd === ex.horaFinalAntigua
          ) {
            e.periodicityExceptionId = ex.id;
            found = true;
          }
        } else {
          const dateFEx =
            ex.horaInicioAntigua === -1
              ? ex.fechaAntigua + " 00:00:00"
              : ex.fechaAntigua + " " + ex.horaInicioAntigua;
          const dateFE =
            e.timeStart === -1
              ? e.date + " 00:00:00"
              : e.date + " " + e.timeStart;
          if (dateFE >= dateFEx) {
            e.periodicityExceptionId = ex.id;
            found = true;
          }
        }
        return found;
      });
      if (ex.tipo === "Edicion") {
        /*const datetimeOld =
          ex.horaInicioAntigua !== -1
            ? ex.fechaAntigua + " " + ex.horaInicioAntigua
            : ex.fechaAntigua + " 00:00:00";
        const datetimeNew =
          ex.horaInicioNueva !== -1
            ? ex.fechaNueva + " " + ex.horaInicioNueva
            : ex.fechaNueva + " 00:00:00";
        const datetimeOldM = moment(datetimeOld, "YYYY-MM-DD HH:mm:ss");
        const datetimeNewM = moment(datetimeNew, "YYYY-MM-DD HH:mm:ss");
        const diff = datetimeNewM.diff(datetimeOldM, "hours");*/

        // Edit events
        evs.forEach((ev) => {
          ev.title = ex.nombre;

          if (ex.aplicableDesdeEsteEvento) {
            // Calculate new dates from this event
            /*const datetimeInicio =
              ev.timeStart !== -1
                ? ev.date + " " + ev.timeStart
                : ev.date + " 00:00:00";
            const datetimeInicioM = moment(
              datetimeInicio,
              "YYYY-MM-DD HH:mm:ss"
            );
            datetimeInicioM.add(diff, "hours");

            const datetimeFin =
              ev.timeEnd !== -1
                ? ev.date + " " + ev.timeEnd
                : ev.date + " 00:00:00";
            const datetimeFinM = moment(datetimeFin, "YYYY-MM-DD HH:mm:ss");
            datetimeFinM.add(diff, "hours");

            ev.date = datetimeInicioM.format("YYYY-MM-DD");
            if (ev.timeStart !== -1) {
              ev.timeStart = datetimeInicioM.format("HH:mm:ss");
              ev.timeEnd = datetimeFinM.format("HH:mm:ss");
            }*/
          } else {
            // Assign datetimes only for this event

            ev.date = ex.fechaNueva;
            ev.timeStart = ex.horaInicioNueva;
            ev.timeEnd = ex.horaFinalNueva;
          }

          if (ev.patient.id !== ex.paciente.id) {
            ev.patient.id = ex.paciente.id;
            ev.patient.name = ex.paciente.nombre;
            ev.patient.lastName = ex.paciente.id;
            ev.pic = null;
          }
          ev.agent = ex.profesional;
          ev.subject = ex.asunto;
        });
      } else {
        // Remove Events
        deployedEvents = deployedEvents.filter((e) => {
          const pos = evs.findIndex((item) => {
            return item.id === e.id;
          });
          return pos === -1;
        });
      }
    });
    return deployedEvents;
  };

  const deployPeriodicEvent = (
    pEvent,
    calendarId,
    minDate,
    maxDate,
    exceptions,
  ) => {
    let mDate = "";
    let evs = [];
    let d = null;
    let counter = 0;
    let its = 0;
    let dF = null;
    let dw = null;

    if (pEvent.numRepeticiones > 0) {
      // Static number of events
      d = moment(pEvent.fecha, "YYYY-MM-DD");
      counter = 0;
      while (counter < pEvent.numRepeticiones) {
        dw = d.format("E");
        dF = d.format("YYYY-MM-DD");
        if (
          pEvent.accionFestivo !== "Ignorar" ||
          (pEvent.accionFestivo === "Ignorar" && dw < "6")
        ) {
          if (pEvent.accionFestivo === "Lunes") {
            switch (dw) {
              case "6":
                dF = moment(d).add(2, "days").format("YYYY-MM-DD");
                break;
              case "7":
                dF = moment(d).add(1, "days").format("YYYY-MM-DD");
                break;
            }
          }
          if (dF >= minDate && dF <= maxDate) {
            const ev = createPeriodicEvent(pEvent, dF, calendarId, counter);
            evs.push(ev);
          }
          counter++;
        }
        its++;
        switch (pEvent.tipo) {
          case "Diario":
            d.add(1, "days");
            break;
          case "Semanal":
            d.add(7, "days");
            break;
          case "Mensual":
            d = moment(pEvent.fecha, "YYYY-MM-DD").add(its, "months");
            break;
          case "Anual":
            d = moment(pEvent.fecha, "YYYY-MM-DD").add(its, "years");
        }
      }
    } else {
      // No static number of events, generate all events until end of date

      if (pEvent.accionFestivo === "Lunes") {
        // Just in case an event from the non represented weekend goes to that first Monday
        minDate = moment(minDate, "YYYY-MM-DD")
          .subtract(2, "days")
          .format("YYYY-MM-DD");
      }
      mDate = pEvent.fecha >= minDate ? pEvent.fecha : minDate;
      counter = 1;
      d = moment(mDate, "YYYY-MM-DD");
      dF = d.format("YYYY-MM-DD");
      let endDate =
        pEvent.fechaFinRepeticion !== "" &&
        (dF <= pEvent.fechaFinRepeticion || pEvent.fechaFinRepeticion < minDate)
          ? pEvent.fechaFinRepeticion
          : maxDate;
      while (dF <= endDate) {
        let realDate = dF;
        let ignore = false;
        dw = d.format("E");
        if (dw >= "6") {
          // Weekend
          switch (pEvent.accionFestivo) {
            case "Ignorar":
              ignore = true;
              break;
            case "Lunes":
              realDate = moment(dF, "YYYY-MM-DD")
                .add(dw === "6" ? 2 : 1, "days")
                .format("YYYY-MM-DD");
              if (realDate > endDate) {
                ignore = true;
              }
              break;
          }
        }
        if (!ignore) {
          switch (pEvent.tipo) {
            case "Semanal":
              if (dw !== moment(pEvent.fecha).format("E")) {
                ignore = true;
              }
              break;
            case "Mensual":
              if (d.format("DD") === moment(d).endOf("month").format("DD")) {
                if (d.format("DD") > moment(pEvent.fecha).format("DD")) {
                  ignore = true;
                }
              } else {
                if (d.format("DD") !== moment(pEvent.fecha).format("DD")) {
                  ignore = true;
                }
              }
              break;
            case "Anual":
              if (d.format("MM-DD") !== moment(pEvent.fecha).format("MM-DD")) {
                ignore = true;
              }
              break;
          }
          if (!ignore) {
            const ev = createPeriodicEvent(
              pEvent,
              realDate,
              calendarId,
              counter,
            );
            evs.push(ev);
            counter++;
          }
        }
        d.add(1, "days");
        dF = d.format("YYYY-MM-DD");
      }
    }

    evs = applyPeriodicExceptions(pEvent, evs, exceptions);

    return evs;
  };

  const loadEvents = async (cals, minDate, maxDate) => {
    const calIds = cals.map((c) => {
      return c.id;
    });

    let response = await rpost("agenda/ListarEventos.php", {
      token: userData.token,
      idUsuario: userData.id,
      idOptica: selectedOptic.id,
      idsCalendario: calIds,
      fechaInicio: minDate,
      fechaFin: maxDate,
    });

    let evs = [];
    response.forEach((cal) => {
      cal.eventos.forEach((event) => {
        const ev = {
          id: event.id,
          title: event.nombre,
          status: event.estado,
          calendarId: cal.idCalendario,
          date: event.fecha,
          timeStart: event.horaInicio,
          timeEnd: event.horaFinal,
          patient: {
            id: event.paciente.id === "" ? -1 : event.paciente.id,
            name: event.paciente.nombre,
            lastName: event.paciente.apellidos,
            pic: null,
            phone: event.paciente.telefono,
          },
          calendarColor: "black",
          visible: true,
          agent: event.profesional,
          subject: event.asunto,
          periodic: false,
          periodicId: -1,
          periodicity: "Diario",
          periodicityOnHolidays: "Mantener",
          periodicityEnd: false,
          periodicityEndType: "RepetirFecha",
          periodicityEndTypeDate: moment().format("YYYY-MM-DD"),
          periodicityNumberRepetitions: "5",
          periodicityExceptionId: -1,
        };

        evs.push(ev);
      });
    });

    /*response = await rpost("agenda/ListarEventosPeriodicos.php", {
      token: userData.token,
      idUsuario: userData.id,
      idsCalendario: calIds,
    });

    const pEventIds = [];
    response.forEach((cal) => {
      cal.eventos.forEach((pEvent) => {
        if (!pEventIds.includes(pEvent.id)) {
          pEventIds.push(pEvent.id);
        }
      });
    });

    let responseEx = await rpost(
      "agenda/ListarEventosPeriodicosExcepciones.php",
      {
        token: userData.token,
        idsEventosPeriodicos: pEventIds,
      },
    );

    const exceptions = [];
    responseEx.forEach((pev) => {
      pev.eventos.forEach((ev) => {
        ev.idEventoPeriodico = pev.idEventoPeriodico;
        exceptions.push(ev);
      });
    });

    response.forEach((cal) => {
      cal.eventos.forEach((pEvent) => {
        const pevs = deployPeriodicEvent(
          pEvent,
          cal.idCalendario,
          minDate,
          maxDate,
          exceptions,
        );
        evs = evs.concat(pevs);
      });
    });*/

    evs.forEach((ev) => {
      const cal = cals.find((c) => {
        return c.id === ev.calendarId;
      });
      if (cal) {
        ev.calendarColor = cal.color;
        ev.visible = cal.visible;
        ev.festivo = cal.festivo;
      }
    });

    for (let i = 0; i < evs.length; i++) {
      const ev = evs[i];
      ev.patient.pic = "";
    }

    // Sort events
    evs = sortEvents(evs);
    setEvents(evs);

    if (showEventsPopup) {
      onSelectPatientEvents(eventsPopupPatient);
    }
  };

  const toggleCalendarVisible = (calendarIndex) => {
    const cals = structuredClone(calendars);
    cals[calendarIndex].visible = !cals[calendarIndex].visible;
    setCalendars(cals);
    calculateMinMaxTime(cals);

    const evs = structuredClone(events);
    evs.forEach((ev) => {
      if (ev.calendarId === cals[calendarIndex].id) {
        ev.visible = cals[calendarIndex].visible;
      }
    });
    setEvents(evs);

    rpost("agenda/GuardarVisibilidadCalendario.php", {
      token: userData.token,
      idUsuario: userData.id,
      idCalendario: cals[calendarIndex].id,
      visible: cals[calendarIndex].visible,
    });
  };

  const debouncedLoadEvents = (cals, minDate, maxDate) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    pendingLoadRef.current = { cals, minDate, maxDate };
    debounceTimerRef.current = setTimeout(() => {
      if (pendingLoadRef.current) {
        const { cals, minDate, maxDate } = pendingLoadRef.current;
        loadEvents(cals, minDate, maxDate);
        pendingLoadRef.current = null;
      }
    }, CALLING_ENDPOINTS_TIME);
  };

  const nextArrow = async () => {
    let date = null;
    let minMaxDates = null;
    switch (selectedCalendarType.id) {
      case "MENSUAL":
        date = moment(selectedDate);
        date.add(1, "months");
        setSelectedDate(date);
        break;
      case "SEMANAL":
        date = moment(selectedDate);
        date.add(7, "days");
        setSelectedDate(date);
        break;
      case "DIARIO":
      case "AGENDA":
        let addDays = 1;
        if (!showWeekends) {
          if (selectedDate.format("d") === "5") {
            addDays = 3;
          }
          if (selectedDate.format("d") === "6") {
            addDays = 2;
          }
        }
        date = moment(selectedDate);
        date.add(addDays, "days");
        setSelectedDate(date);
        break;
    }
    setEvents([]);
    minMaxDates = calculateMinMaxDate(date, selectedCalendarType.id);
    debouncedLoadEvents(calendars, minMaxDates.min, minMaxDates.max);
  };

  const previousArrow = async () => {
    let date = null;
    let minMaxDates = null;
    switch (selectedCalendarType.id) {
      case "MENSUAL":
        date = moment(selectedDate);
        date.add(-1, "months");
        setSelectedDate(date);
        break;
      case "SEMANAL":
        date = moment(selectedDate);
        date.add(-7, "days");
        setSelectedDate(date);
        break;
      case "DIARIO":
      case "AGENDA":
        let addDays = -1;
        if (!showWeekends) {
          if (selectedDate.format("d") === "1") {
            addDays = -3;
          }
          if (selectedDate.format("d") === "60") {
            addDays = -2;
          }
        }
        date = moment(selectedDate);
        date.add(addDays, "days");
        setSelectedDate(date);
        break;
    }
    setEvents([]);
    minMaxDates = calculateMinMaxDate(date, selectedCalendarType.id);
    debouncedLoadEvents(calendars, minMaxDates.min, minMaxDates.max);
  };

  const changeCalendar = (cal) => {
    setSelectedCalendarType(cal);
    setSelectedDate(moment());
    setEvents([]);
    const minMaxDates = calculateMinMaxDate(moment(), cal.id);
    loadEvents(calendars, minMaxDates.min, minMaxDates.max);
  };

  const selectDay = (date) => {
    setSelectedDate(date);
    setEvents([]);
    const minMaxDates = calculateMinMaxDate(date, selectedCalendarType.id);
    loadEvents(calendars, minMaxDates.min, minMaxDates.max);
  };

  const handleTodayClick = () => {
    selectDay(moment());

    // Cancel any existing animations and reset element styles
    animationTimeoutsRef.current.forEach((timeout) => clearTimeout(timeout));
    animationTimeoutsRef.current = [];

    // Reset styles for both monthly and weekly calendar
    const todayElement = document.getElementById("calendar-month-day-today");
    if (todayElement) {
      todayElement.style.transition = "";
      todayElement.style.backgroundColor = "";
    }

    const weekTodayElements = document.querySelectorAll(
      ".calendar-week-day-today",
    );
    weekTodayElements.forEach((el) => {
      el.style.transition = "";
      el.style.backgroundColor = "";
    });

    // Wait for DOM to update and then animate
    const timeout1 = setTimeout(() => {
      // Animate monthly calendar element
      const todayElement = document.getElementById("calendar-month-day-today");
      if (todayElement) {
        const originalColor = todayElement.style.backgroundColor || "";
        todayElement.style.transition = `background-color ${FLASH_DAY_TIME / 1000}s`;
        todayElement.style.backgroundColor = "#e2f5ff";

        const timeout2 = setTimeout(() => {
          todayElement.style.backgroundColor = originalColor;
          const timeout3 = setTimeout(() => {
            todayElement.style.transition = "";
          }, FLASH_DAY_TIME);
          animationTimeoutsRef.current.push(timeout3);
        }, FLASH_DAY_TIME);
        animationTimeoutsRef.current.push(timeout2);
      }

      // Animate weekly calendar elements
      const weekTodayElements = document.querySelectorAll(
        ".calendar-week-day-today",
      );
      weekTodayElements.forEach((element) => {
        const originalColor = element.style.backgroundColor || "";
        element.style.transition = `background-color ${FLASH_DAY_TIME / 1000}s`;
        element.style.backgroundColor = "#e2f5ff";

        const timeout2 = setTimeout(() => {
          element.style.backgroundColor = originalColor;
          const timeout3 = setTimeout(() => {
            element.style.transition = "";
            animationTimeoutsRef.current = [];
          }, FLASH_DAY_TIME);
          animationTimeoutsRef.current.push(timeout3);
        }, FLASH_DAY_TIME);
        animationTimeoutsRef.current.push(timeout2);
      });
    }, 100);
    animationTimeoutsRef.current.push(timeout1);
  };

  const openCalendarPopup = (id) => {
    const cal = {
      id: -1,
      name: "",
      color: "#E67C73",
      visible: true,
      minTime: 10,
      maxTime: 20,
      users: [],
      iCanEdit: true,
    };
    if (id === -1) {
      cal.users.push({
        id: userData.id,
        name: userData.nombre,
        lastName: userData.apellidos,
        pic: userData.pic,
        readOnly: false,
      });
      setSelectedAgents([userData.nombre + " " + userData.apellidos]);
      setRangeMinTime({
        id: CALENDAR_HOURS_COMPLETE[10].id,
        text: CALENDAR_HOURS_COMPLETE[10].text,
      });
      setRangeMaxTime({
        id: CALENDAR_HOURS_COMPLETE[20].id,
        text: CALENDAR_HOURS_COMPLETE[20].text,
      });
    } else {
      const c = calendars.find((item) => {
        return item.id === id;
      });
      if (c) {
        let mTime =
          c.minTime < 10 ? "0" + c.minTime.toString() : c.minTime.toString();
        mTime += ":00";
        let MTime =
          c.maxTime < 10 ? "0" + c.maxTime.toString() : c.maxTime.toString();
        MTime += ":00";

        setRangeMinTime({ id: mTime, text: mTime });
        setRangeMaxTime({ id: MTime, text: MTime });

        cal.id = c.id;
        cal.name = c.name;
        cal.color = c.color;
        cal.visible = c.visible;
        cal.minTime = c.minTime;
        cal.maxTime = c.maxTime;
        cal.users = structuredClone(c.users);
        cal.iCanEdit = c.iCanEdit;

        const selectedAgentsN = cal.users.map((u) => {
          return u.name + " " + u.lastName;
        });
        setSelectedAgents(selectedAgentsN);
      }
    }
    setCalendarEdit(cal);
  };

  const openEventPopup = () => {
    if (calendars.length === 0) {
      createPopupQuestion(
        "Debe crear algún calendario antes de crear citas.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
      return;
    }
    const event = {
      id: -1,
      title: "",
      calendarId: -1,
      status: EVENT_STATUS[1].id,
      date: moment().format("YYYY-MM-DD"),
      timeStart: "10:00:00",
      timeEnd: "11:00:00",
      patient: {
        id: -1,
        name: "",
        lastName: "",
        pic: null,
        phone: "",
      },
      calendarColor: "",
      visible: true,
      agent: "",
      subject: "",
      periodic: false,
      periodicId: -1,
      periodicity: "Diario",
      periodicityOnHolidays: "Mantener",
      periodicityEnd: false,
      periodicityEndType: "RepetirFecha",
      periodicityEndTypeDate: moment().format("YYYY-MM-DD"),
      periodicityNumberRepetitions: "5",
    };
    setEditEvent(event);
  };

  const closeEventPopup = () => {
    setEditEvent(null);
  };

  const onSaveEvent = (ev) => {
    createPopupQuestion(
      "Cita guardada correctamente.",
      removePopupQuestion,
      null,
      "Cerrar",
      "",
    );
    setEditEvent(null);
    const minMaxDates = calculateMinMaxDate(
      selectedDate,
      selectedCalendarType.id,
    );
    loadEvents(calendars, minMaxDates.min, minMaxDates.max);
  };

  const onDeleteEvent = (ev) => {
    setEditEvent(null);
    const minMaxDates = calculateMinMaxDate(
      selectedDate,
      selectedCalendarType.id,
    );
    loadEvents(calendars, minMaxDates.min, minMaxDates.max);
  };

  const clickShowWeekends = (show) => {
    setShowWeekends(show);
    rpost("agenda/GuardarAjustesCalendarios.php", {
      token: userData.token,
      idUsuario: userData.id,
      mostrarFinesDeSemana: show,
    });
  };

  const clickEvent = (ev) => {
    const cal = calendars.find((c) => {
      return c.id === ev.calendarId;
    });
    if (cal.iCanEdit) {
      const event = structuredClone(ev);
      if (event.patient == null) {
        event.patient = {
          id: -1,
          name: "",
          lastName: "",
          pic: null,
          phone: "",
        };
      }
      setEditEvent(event);
    } else {
      createPopupQuestion(
        "No tienes permisos para realizar modificaciones en citas de este calendario.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
    }
  };

  const clickSlot = (day, time) => {
    if (calendars.length === 0) {
      createPopupQuestion(
        "Debe crear algún calendario antes de crear citas.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
      return;
    }
    let timeStart = "10:00:00";
    let timeEnd = "11:00:00";
    if (time) {
      timeStart = time;
      timeEnd = moment(time, "HH:mm:ss").add(1, "hours").format("HH:mm:ss");
    }
    const event = {
      id: -1,
      title: "",
      calendarId: -1,
      status: EVENT_STATUS[1].id,
      date: day,
      timeStart: timeStart,
      timeEnd: timeEnd,
      patient: {
        id: -1,
        name: "",
        lastName: "",
        pic: null,
        phone: "",
      },
      calendarColor: "",
      visible: true,
      agent: "",
      subject: "",
      periodic: false,
      periodicId: -1,
      periodicity: "Diario",
      periodicityOnHolidays: "Mantener",
      periodicityEnd: false,
      periodicityEndType: "RepetirFecha",
      periodicityEndTypeDate: day,
      periodicityNumberRepetitions: "5",
    };
    setEditEvent(event);
  };

  const saveCalendar = async () => {
    const u = calendarEdit.users.filter((item) => {
      return !item.readOnly;
    });
    if (u.length === 0) {
      createPopupQuestion(
        `Al menos debe haber un usuario con derechos de escritura sobre el calendario.`,
        removePopupQuestion,
        null,
      );
      return;
    }

    if (calendarEdit.name.trim() === "") {
      createPopupQuestion(
        "Debe asignar un nombre al calendario.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
      return;
    }

    let minTime =
      calendarEdit.minTime < 10
        ? "0" + calendarEdit.minTime.toString()
        : calendarEdit.minTime.toString();
    minTime += ":00:00";
    let maxTime =
      calendarEdit.maxTime < 10
        ? "0" + calendarEdit.maxTime.toString()
        : calendarEdit.maxTime.toString();
    maxTime += ":00:00";
    const users = calendarEdit.users.map((user) => {
      return {
        id: user.id,
        soloLectura: user.readOnly,
      };
    });
    await rpost("agenda/GuardarCalendario.php", {
      token: userData.token,
      idUsuario: userData.id,
      idCalendario: calendarEdit.id,
      nombre: calendarEdit.name,
      color: calendarEdit.color,
      horaInicio: minTime,
      horaFin: maxTime,
      usuarios: users,
    });

    setCalendarEdit(null);

    loadCalendars();
  };

  const deleteCalendar = () => {
    createPopupQuestion(
      "¿Desea eliminar el calendario " + calendarEdit.name + "?",
      async () => {
        await rpost("agenda/BorrarCalendario.php", {
          token: userData.token,
          idUsuario: userData.id,
          idCalendario: calendarEdit.id,
        });
        removePopupQuestion();
        setCalendarEdit(null);
        loadCalendars();
      },
      removePopupQuestion,
      "Eliminar",
      "Cancelar",
    );
    return;
  };

  const onChangeRangeMinTime = (e) => {
    setRangeMinTime(e);
    calendarEdit.minTime = parseInt(e.text.split(":")[0]);
    setCalendarEdit(calendarEdit);
  };

  const onChangeRangeMaxTime = (e) => {
    setRangeMaxTime(e);
    calendarEdit.maxTime = parseInt(e.text.split(":")[0]);
    setCalendarEdit(calendarEdit);
  };

  const onClickMoreEvents = (day) => {
    const dayFormatted = day.format("YYYY-MM-DD");
    const listedEventsDayN = events.filter((event) => {
      return event.visible && event.date === dayFormatted;
    });
    setListedEventsDate(listedEventsDayN);
    setListedEventsDateDay(day);
  };

  const onClickTitleEvents = (day) => {
    setSelectedDate(day);
    setSelectedCalendarType(CALENDAR_TYPE_OPTIONS[2]);
  };

  const closeListedEvents = () => {
    setListedEventsDate([]);
    setListedEventsDateDay(null);
  };

  const openEventsPopup = (show) => {
    setShowEventsPopup(show);
    if (show) {
      setTimeout(() => {
        const el = document.getElementById("contactonombrecitas");
        if (el) el.focus();
      }, 100);
    } else {
      setEventsPopupPatient(null);
      setEventsPopupEventsPast(null);
      setEventsPopupEventsFuture(null);
    }
  };

  const onSelectPatientEvents = async (e) => {
    setEventsPopupPatient(e);
    const response = await rpost("agenda/ObtenerEventosPaciente.php", {
      token: userData.token,
      idUsuario: userData.id,
      idPaciente: e.idPaciente,
    });

    let evs = [];
    response.forEach((cal) => {
      cal.eventos.forEach((event) => {
        const ev = {
          id: event.id,
          title: event.nombre,
          status: event.estado,
          calendarId: cal.idCalendario,
          date: event.fecha,
          timeStart: event.horaInicio,
          timeEnd: event.horaFinal,
          patient: {
            id: event.paciente.id === "" ? -1 : event.paciente.id,
            name: event.paciente.nombre,
            lastName: event.paciente.apellidos,
            pic: null,
          },
          calendarColor: "black",
          visible: true,
          agent: event.profesional,
          subject: event.asunto,
          periodic: false,
          periodicId: -1,
          periodicity: "Diario",
          periodicityOnHolidays: "Mantener",
          periodicityEnd: false,
          periodicityEndType: "RepetirFecha",
          periodicityEndTypeDate: moment().format("YYYY-MM-DD"),
          periodicityNumberRepetitions: "5",
          periodicityExceptionId: -1,
        };

        evs.push(ev);
      });
    });

    evs = evs.reduce((acc, curr) => {
      const cal = calendars.find((c) => {
        return c.id === curr.calendarId;
      });
      if (cal) {
        curr.calendarColor = cal.color;
        curr.visible = cal.visible;
        acc.push(curr);
      }
      return acc;
    }, []);

    // Sort events
    evs = sortEvents(evs);

    const now = moment();
    const past = evs.filter((ev) => {
      if (ev.timeStart === -1) {
        return moment(ev.date, "YYYY-MM-DD").isBefore(now, "day");
      }
      return moment(
        ev.date + " " + ev.timeStart,
        "YYYY-MM-DD HH:mm:ss",
      ).isBefore(now);
    });
    const future = evs.filter((ev) => {
      if (ev.timeStart === -1) {
        return !moment(ev.date, "YYYY-MM-DD").isBefore(now, "day");
      }
      return !moment(
        ev.date + " " + ev.timeStart,
        "YYYY-MM-DD HH:mm:ss",
      ).isBefore(now);
    });
    setEventsPopupEventsPast(past);
    setEventsPopupEventsFuture(future);
  };

  const loadLastPatient = () => {
    const patient = JSON.parse(localStorage.getItem("lastUser"));
    if (patient) {
      onSelectPatientEvents({
        idPaciente: patient.id,
        nombre: patient.name,
        apellidos: patient.lastName,
      });
    }
  };

  useEffect(() => {
    if (show) {
      loadAgents();
      loadCalendars();
      const tod = getToday();
      if (tod !== today) {
        setToday(tod);
      }
    }
  }, [show]);

  const buildDayEvents = () => {
    const evs = events.filter((ev) => {
      return (
        ev.visible &&
        ev.date === selectedDate.format("YYYY-MM-DD") &&
        ev.timeStart === -1
      );
    });
    setDayEvents(evs);
  };

  useEffect(() => {
    //console.log("EVENTS", events);
    buildDayEvents();

    if (listedEventsDateDay) {
      // Rebuild listed events in popup if open
      onClickMoreEvents(listedEventsDateDay);
    }

    //console.log("EVENTS", events);
  }, [events]);

  useEffect(() => {
    selectedDateRef.current = selectedDate;
  }, [selectedDate]);

  useEffect(() => {
    calendarsRef.current = calendars;
  }, [calendars]);

  useEffect(() => {
    if (selectedCalendarType.id === "MENSUAL" && monthlyCalendarRef.current) {
      const handleWheel = (e) => {
        e.preventDefault();

        let date = null;
        let minMaxDates = null;

        if (e.deltaY < 0) {
          // Previous month
          date = moment(selectedDateRef.current);
          date.add(-1, "months");
          setSelectedDate(date);
          setEvents([]);
          minMaxDates = calculateMinMaxDate(date, selectedCalendarType.id);
          debouncedLoadEvents(
            calendarsRef.current,
            minMaxDates.min,
            minMaxDates.max,
          );
        } else if (e.deltaY > 0) {
          // Next month
          date = moment(selectedDateRef.current);
          date.add(1, "months");
          setSelectedDate(date);
          setEvents([]);
          minMaxDates = calculateMinMaxDate(date, selectedCalendarType.id);
          debouncedLoadEvents(
            calendarsRef.current,
            minMaxDates.min,
            minMaxDates.max,
          );
        }
      };

      const calendarElement = monthlyCalendarRef.current;
      calendarElement.addEventListener("wheel", handleWheel, {
        passive: false,
      });

      return () => {
        calendarElement.removeEventListener("wheel", handleWheel);
      };
    }

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [selectedCalendarType]);

  useEffect(() => {
    if (calendarEdit && selectedAgents) {
      let ags = null;
      if (selectedAgents.length === 0) {
        ags = [
          {
            id: userData.id,
            name: userData.nombre + " " + userData.apellidos,
            lastName: "",
            pic: null,
            readOnly: false,
          },
        ];
        setSelectedAgents([userData.nombre + " " + userData.apellidos]);
      } else {
        ags = selectedAgents.map((agent) => {
          const a = agents.find((item) => {
            return item.nombreApellidos === agent;
          });
          const ca = calendarEdit.users.find((u) => {
            return u.name + " " + u.lastName === agent;
          });
          const readOnly = ca ? ca.readOnly : false;
          return {
            id: a.id,
            name: a.nombreApellidos,
            lastName: "",
            pic: "",
            readOnly,
          };
        });
      }
      const cal = structuredClone(calendarEdit);
      cal.users = ags;
      setCalendarEdit(cal);
    }
  }, [selectedAgents]);

  if (!show) {
    return <></>;
  }

  return (
    <div className="patient-data patient-data-calendar">
      <div className="patient-data-header">
        <span className="header-text">Agenda</span>
      </div>
      <div className="patient-data-content patient-data-content-calendar">
        <div className="calendar-container">
          <div className="calendar-menu">
            <div className="calendar-menu-header">
              <div className="calendar-calendar-footer mes">
                <div
                  className="calendar-calendar-footer-info calendarArrow"
                  onClick={() => previousArrow()}
                >
                  &lt;
                </div>
                <div className="calendar-calendar-footer-info calendarFooterText">
                  {monthNumberToName(selectedDate.format("MM"), true)}{" "}
                  {selectedDate.format("YYYY")}
                </div>
                <div
                  className="calendar-calendar-footer-info calendarArrow"
                  onClick={() => nextArrow()}
                >
                  &gt;
                </div>
              </div>
            </div>
            <div className="calendar-menu-header">
              <div
                className="calendar-add-appointment"
                onClick={openEventPopup}
              >
                <img
                  src="/images/add-white.svg"
                  loading="lazy"
                  alt=""
                  className="calendar-add-appointment-img"
                />
              </div>
              <ButtonIconHToday
                text="Hoy"
                small={true}
                onClick={() => {
                  handleTodayClick();
                }}
                onChangeDay={(e) => {
                  selectDay(moment(e, "YYYY-MM-DD"));
                }}
                tabIndex={1}
              />
              <Dropdown
                id="calendar-types"
                tabIndex={2}
                optionList={CALENDAR_TYPE_OPTIONS}
                size={1}
                op={selectedCalendarType.id}
                onChange={(e) => {
                  changeCalendar(e);
                }}
              />
            </div>
            {calendars.map((calendar, i) => {
              return (
                <CalendarItem
                  key={calendar.id}
                  id={calendar.id}
                  name={calendar.name}
                  color={calendar.color}
                  users={calendar.users}
                  visible={calendar.visible}
                  iCanEdit={calendar.iCanEdit}
                  onClickVisible={() => toggleCalendarVisible(i)}
                  onClickCalendar={(id) => openCalendarPopup(id)}
                />
              );
            })}
            <div className="calendar-menu-body">
              <ButtonIconH
                text="Añadir calendario"
                small={true}
                onClick={() => {
                  openCalendarPopup(-1);
                }}
              />
            </div>
            {showWeekends != null && (
              <div className="calendar-menu-body calendar-menu-item-option">
                <div
                  className="data-field c-pointer"
                  onClick={() => {
                    clickShowWeekends(!showWeekends);
                  }}
                >
                  <CheckBox
                    tabIndex={3}
                    active={showWeekends}
                    onClick={() => {}}
                  />
                  <span className="label">Mostrar fin de semana</span>
                </div>
              </div>
            )}
            <div className="calendar-show-events">
              <ButtonIconH
                text="Ver citas"
                small={true}
                onClick={() => {
                  openEventsPopup(true);
                }}
              />
            </div>
          </div>
          <div className="full-calendar">
            {/* CALENDARIO MENSUAL */}

            {selectedCalendarType.id === "MENSUAL" && (
              <div className="calendar-calendar">
                <div className="calendar-calendar-mes" ref={monthlyCalendarRef}>
                  <div className="calendar-calendar-mes-menu-dia">
                    <div
                      className="calendar-calendar-footer-info calendarArrow calendarArrowLeft"
                      onClick={() => previousArrow()}
                    >
                      &lt;
                    </div>
                    <CalendarMCellTitle text="Lun" />
                    <CalendarMCellTitle text="Mar" />
                    <CalendarMCellTitle text="Mie" />
                    <CalendarMCellTitle text="Jue" />
                    <CalendarMCellTitle text="Vie" />
                    {showWeekends && <CalendarMCellTitle text="Sáb" />}
                    {showWeekends && <CalendarMCellTitle text="Dom" />}
                    <div
                      className="calendar-calendar-footer-info calendarArrow calendarArrowRight"
                      onClick={() => nextArrow()}
                    >
                      &gt;
                    </div>
                  </div>
                  <CalendarMRow
                    selectedDate={selectedDate}
                    numWeek={1}
                    events={events}
                    showWeekends={showWeekends}
                    onClickEvent={clickEvent}
                    onClickSlot={clickSlot}
                    onClickMore={(day) => onClickMoreEvents(day)}
                    onClickTitle={(day) => onClickTitleEvents(day)}
                  />
                  <CalendarMRow
                    selectedDate={selectedDate}
                    numWeek={2}
                    events={events}
                    showWeekends={showWeekends}
                    onClickEvent={clickEvent}
                    onClickSlot={clickSlot}
                    onClickMore={(day) => onClickMoreEvents(day)}
                    onClickTitle={(day) => onClickTitleEvents(day)}
                  />
                  <CalendarMRow
                    selectedDate={selectedDate}
                    numWeek={3}
                    events={events}
                    showWeekends={showWeekends}
                    onClickEvent={clickEvent}
                    onClickSlot={clickSlot}
                    onClickMore={(day) => onClickMoreEvents(day)}
                    onClickTitle={(day) => onClickTitleEvents(day)}
                  />
                  <CalendarMRow
                    selectedDate={selectedDate}
                    numWeek={4}
                    events={events}
                    showWeekends={showWeekends}
                    onClickEvent={clickEvent}
                    onClickSlot={clickSlot}
                    onClickMore={(day) => onClickMoreEvents(day)}
                    onClickTitle={(day) => onClickTitleEvents(day)}
                  />
                  <CalendarMRow
                    selectedDate={selectedDate}
                    numWeek={5}
                    events={events}
                    showWeekends={showWeekends}
                    onClickEvent={clickEvent}
                    onClickSlot={clickSlot}
                    onClickMore={(day) => onClickMoreEvents(day)}
                    onClickTitle={(day) => onClickTitleEvents(day)}
                  />
                  <CalendarMRow
                    selectedDate={selectedDate}
                    numWeek={6}
                    events={events}
                    showWeekends={showWeekends}
                    onClickEvent={clickEvent}
                    onClickSlot={clickSlot}
                    onClickMore={(day) => onClickMoreEvents(day)}
                    onClickTitle={(day) => onClickTitleEvents(day)}
                  />
                </div>
              </div>
            )}

            {/* CALENDARIO SEMANAL */}

            {selectedCalendarType.id === "SEMANAL" && (
              <div className="calendar-calendar semana">
                <div className="calendar-calendar-horas">
                  <div className="calendar-calendar-horas-header">
                    <div className="clendar-calendar-horas-menu">
                      <div className="calendar-day-header-space"></div>
                      <div className="calendar-calendar-horas-menu-semana">
                        <div
                          className="calendar-calendar-footer-info calendarArrow calendarArrowLeft"
                          onClick={() => previousArrow()}
                        >
                          &lt;
                        </div>
                        <CalendarWCellTitle
                          selectedDate={selectedDate}
                          numDay={1}
                          events={events}
                          onClickEvent={clickEvent}
                        />
                        <CalendarWCellTitle
                          selectedDate={selectedDate}
                          numDay={2}
                          events={events}
                          onClickEvent={clickEvent}
                        />
                        <CalendarWCellTitle
                          selectedDate={selectedDate}
                          numDay={3}
                          events={events}
                          onClickEvent={clickEvent}
                        />
                        <CalendarWCellTitle
                          selectedDate={selectedDate}
                          numDay={4}
                          events={events}
                          onClickEvent={clickEvent}
                        />
                        <CalendarWCellTitle
                          selectedDate={selectedDate}
                          numDay={5}
                          events={events}
                          onClickEvent={clickEvent}
                        />
                        {showWeekends && (
                          <CalendarWCellTitle
                            selectedDate={selectedDate}
                            numDay={6}
                            events={events}
                            onClickEvent={clickEvent}
                          />
                        )}
                        {showWeekends && (
                          <CalendarWCellTitle
                            selectedDate={selectedDate}
                            numDay={7}
                            events={events}
                            onClickEvent={clickEvent}
                          />
                        )}
                        <div
                          className="calendar-calendar-footer-info calendarArrow calendarArrowRight"
                          onClick={() => nextArrow()}
                        >
                          &gt;
                        </div>
                      </div>
                    </div>
                    <div className="calendar-calendar-horas-gmt">
                      <div className="calendar-gmt">
                        <div className="calendar-gmt-text">GMT +02</div>
                      </div>
                      <div className="calendar-calendar-horas-menu-semana">
                        <CalendarWCellTitleSeparator />
                        <CalendarWCellTitleSeparator />
                        <CalendarWCellTitleSeparator />
                        <CalendarWCellTitleSeparator />
                        <CalendarWCellTitleSeparator />
                        {showWeekends && <CalendarWCellTitleSeparator />}
                        {showWeekends && <CalendarWCellTitleSeparator />}
                      </div>
                    </div>
                  </div>
                  <div className="calendar-week-container">
                    {Array.from({ length: maxTime - minTime }, (_, i) => (
                      <CalendarWRow
                        key={i}
                        time={hourNumberToTime(minTime + i)}
                        selectedDate={selectedDate}
                        showWeekends={showWeekends}
                        events={events}
                        onClickEvent={clickEvent}
                        onClickSlot={clickSlot}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* CALENDARIO DIARIO */}

            {selectedCalendarType.id === "DIARIO" && (
              <div className="calendar-calendar semana diario">
                <div className="calendar-calendar-horas">
                  <div className="calendar-dia-header">
                    <div className="clendar-calendar-horas-menu">
                      <div className="calendar-day-header-space"></div>
                      <div className="calendar-calendar-horas-menu-semana">
                        <div className="calendar-calendar-horas-menu-dia">
                          <div
                            className={`text-dias-semanas ${
                              selectedDate.format("YYYY-MM-DD") ===
                              moment().format("YYYY-MM-DD")
                                ? "hoy"
                                : ""
                            }`}
                          >
                            {dayNumberToName(
                              selectedDate.format("E"),
                              true,
                            ).slice(0, 3)}
                          </div>
                          <div
                            className={`text-dias-semanas-dia ${
                              selectedDate.format("YYYY-MM-DD") ===
                              moment().format("YYYY-MM-DD")
                                ? "hoy"
                                : ""
                            }`}
                          >
                            <div
                              className="calendar-calendar-footer-info calendarArrow calendarArrowLeft"
                              onClick={() => previousArrow()}
                            >
                              &lt;
                            </div>
                            {selectedDate.format("DD") +
                              " " +
                              monthNumberToName(
                                selectedDate.format("MM"),
                                true,
                              ).slice(0, 3)}
                            <div
                              className="calendar-calendar-footer-info calendarArrow calendarArrowRight"
                              onClick={() => nextArrow()}
                            >
                              &gt;
                            </div>
                          </div>
                          <div className="calendar-event-slot clickable-slot title-slot calendar-day-events-day">
                            {dayEvents.map((event, index) => {
                              return (
                                <SlotEventCard
                                  key={index}
                                  event={event}
                                  numEvent={index}
                                  numEvents={dayEvents.length}
                                  onClickEvent={() => clickEvent(event)}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="calendar-calendar-horas-gmt">
                      <div className="calendar-gmt">
                        <div className="calendar-gmt-text">GMT +02</div>
                      </div>
                      <div className="calendar-calendar-horas-menu-semana">
                        <div className="calendar-calendar-horas-menu-semana-separador"></div>
                      </div>
                    </div>
                  </div>
                  <div className="calendar-week-container">
                    {Array.from({ length: maxTime - minTime }, (_, i) => (
                      <CalendarDRow
                        key={i}
                        time={hourNumberToTime(minTime + i)}
                        selectedDate={selectedDate}
                        events={events}
                        onClickEvent={clickEvent}
                        onClickSlot={clickSlot}
                      />
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* AGENDA */}

            {selectedCalendarType.id === "AGENDA" && (
              <div className="calendar-calendar semana diario">
                <div className="calendar-calendar-horas">
                  <div className="calendar-dia-header">
                    <div className="clendar-calendar-horas-menu">
                      <div className="calendar-day-header-space"></div>
                      <div className="calendar-calendar-horas-menu-semana">
                        <div className="calendar-calendar-horas-menu-dia">
                          <div
                            className={`text-dias-semanas ${
                              selectedDate.format("YYYY-MM-DD") ===
                              moment().format("YYYY-MM-DD")
                                ? "hoy"
                                : ""
                            }`}
                          >
                            {dayNumberToName(
                              selectedDate.format("E"),
                              true,
                            ).slice(0, 3)}
                          </div>
                          <div
                            className={`text-dias-semanas-dia ${
                              selectedDate.format("YYYY-MM-DD") ===
                              moment().format("YYYY-MM-DD")
                                ? "hoy"
                                : ""
                            }`}
                          >
                            <div
                              className="calendar-calendar-footer-info calendarArrow calendarArrowLeft"
                              onClick={() => previousArrow()}
                            >
                              &lt;
                            </div>
                            {selectedDate.format("DD") +
                              " " +
                              monthNumberToName(
                                selectedDate.format("MM"),
                                true,
                              ).slice(0, 3)}
                            <div
                              className="calendar-calendar-footer-info calendarArrow calendarArrowRight"
                              onClick={() => nextArrow()}
                            >
                              &gt;
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="calendar-week-container">
                    <div className="calendar-agenda-container">
                      {events.map((event) => {
                        return (
                          <CalendarARow
                            key={event.id}
                            event={event}
                            onClickEvent={(ev) => clickEvent(ev)}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {calendarEdit && (
        <div className="popup-container secondary">
          <div className="popup-message">
            <div className="popup-calendario">
              <PopupTitle
                title={`${
                  calendarEdit.id === -1 ? "Crear" : "Editar"
                } calendario`}
                onClose={() => setCalendarEdit(null)}
              />
            </div>
            <div className="popup-calendar-body">
              <div className="popup-calendar-contenido">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <CalendarColorSelector
                    color="#E67C73"
                    selected={calendarEdit.color === "#E67C73"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#F6BF26"
                    selected={calendarEdit.color === "#F6BF26"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#33B679"
                    selected={calendarEdit.color === "#33B679"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#4285F4"
                    selected={calendarEdit.color === "#4285F4"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#9E69AF"
                    selected={calendarEdit.color === "#9E69AF"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#A79B8E"
                    selected={calendarEdit.color === "#A79B8E"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#AD1457"
                    selected={calendarEdit.color === "#AD1457"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#F4511E"
                    selected={calendarEdit.color === "#F4511E"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#0B8043"
                    selected={calendarEdit.color === "#0B8043"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#3F51B5"
                    selected={calendarEdit.color === "#3F51B5"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#8E24AA"
                    selected={calendarEdit.color === "#8E24AA"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                  <CalendarColorSelector
                    color="#795548"
                    selected={calendarEdit.color === "#795548"}
                    onClick={(color) => {
                      const cal = { ...calendarEdit };
                      cal.color = color;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={100}
                  />
                </div>
                <div className="popup-calendar-contenido-element">
                  <div className="label calendar-popup-label">Nombre</div>
                  <InputData
                    maxLength={60}
                    inactive={false}
                    type="type-alphanum"
                    size={0}
                    input={calendarEdit.name}
                    onChange={(text) => {
                      const cal = { ...calendarEdit };
                      cal.name = text;
                      setCalendarEdit(cal);
                    }}
                    tabIndex={101}
                  />
                </div>
                <div className="popup-calendar-contenido-element time-range">
                  <div className="label calendar-popup-label">
                    Franja Horaria
                  </div>
                  <div className="popup-event-times">
                    <Dropdown
                      id="calendar-types"
                      tabIndex={102}
                      optionList={CALENDAR_HOURS_COMPLETE}
                      size={1}
                      op={rangeMinTime.id}
                      onChange={onChangeRangeMinTime}
                    />
                    <span>-</span>
                    <Dropdown
                      id="calendar-types"
                      tabIndex={103}
                      optionList={CALENDAR_HOURS_COMPLETE}
                      size={1}
                      op={rangeMaxTime.id}
                      onChange={onChangeRangeMaxTime}
                    />
                  </div>
                </div>
                <div className="popup-calendar-contenido-element input-users">
                  <div className="label calendar-popup-label">Agente</div>
                  <InputIconSearchPanelMultiSelection
                    size={0}
                    tabIndex={104}
                    inactive={false}
                    type={"type-alphanum-ext"}
                    options={agentList}
                    selectedOptions={selectedAgents}
                    onChange={(e) => {
                      setSelectedAgents(e);
                    }}
                  />
                </div>
                <div className="popup-calendar-contenido-user-group">
                  {calendarEdit.users.map((user) => {
                    return (
                      <CalendarPeopleOption
                        key={user.id}
                        id={user.id}
                        name={user.name}
                        lastName={user.lastName}
                        calendarColor={calendarEdit.color}
                        pic={user.pic}
                        permission={
                          user.readOnly
                            ? { id: "LECTURA", text: "LECTURA" }
                            : { id: "ESCRITURA", text: "LECTURA" }
                        }
                        onChangePermission={(opt) => {
                          const cal = structuredClone(calendarEdit);
                          const u = cal.users.find((item) => {
                            return item.id === user.id;
                          });
                          if (u) {
                            u.readOnly = opt.id === "LECTURA";
                          }
                          setCalendarEdit(cal);
                        }}
                        readOnly={false}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="popup-row-buttons-container">
                <div className="popup-row-buttons">
                  <ButtonIconH
                    disabled={calendarEdit.id === -1}
                    text="Eliminar"
                    onClick={deleteCalendar}
                  />
                  <ButtonIconH
                    text="Cancelar"
                    onClick={() => setCalendarEdit(null)}
                  />
                  <ButtonIconH text="Guardar" onClick={saveCalendar} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {listedEventsDateDay && (
        <div className="popup-container secondary">
          <div className="popup-message">
            <div className="popup-calendario">
              <PopupTitle
                title={`Citas - ${
                  listedEventsDateDay.format("DD") +
                  " " +
                  monthNumberToName(
                    listedEventsDateDay.format("MM"),
                    true,
                  ).slice(0, 3) +
                  " " +
                  listedEventsDateDay.format("YYYY")
                }`}
                onClose={() => closeListedEvents()}
              />
            </div>
            <div className="popup-calendar-body">
              <div className="popup-calendar-contenido">
                <div className="calendar-day-events-list">
                  {listedEventsDate.map((event, index) => {
                    return (
                      <SlotEventCardSimple
                        key={index}
                        event={event}
                        numEvents={1}
                        numEvent={0}
                        onClickEvent={clickEvent}
                        forceSmall={false}
                        bigText={true}
                      />
                    );
                  })}
                </div>
              </div>
              <div className="popup-row-buttons-container">
                <div className="popup-row-buttons">
                  <ButtonIconH
                    text="Cerrar"
                    onClick={() => closeListedEvents()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showEventsPopup && (
        <div className="popup-container secondary patient-events-list">
          <div className="popup-message">
            <div className="popup-calendario">
              <PopupTitle
                title="Citas"
                onClose={() => openEventsPopup(false)}
              />
            </div>
            <div className="popup-calendar-body">
              <div className="popup-calendar-contenido">
                <div className="popup-calendar-contenido-element">
                  <div className="label calendar-popup-label">Paciente</div>
                  <InputSearch
                    id="contactonombrecitas"
                    tabIndex={305}
                    type="type-alpha"
                    size={3}
                    op={
                      eventsPopupPatient
                        ? eventsPopupPatient.idPaciente === -1
                          ? eventsPopupPatient.nombre
                          : eventsPopupPatient.nombre +
                            " " +
                            eventsPopupPatient.apellidos
                        : null
                    }
                    onSelect={onSelectPatientEvents}
                    showCode={false}
                    onChange={null}
                  />
                  <button
                    className="cell-icon"
                    onClick={() => loadLastPatient()}
                  >
                    <img
                      src="/images/support-extra/patient.svg"
                      loading="lazy"
                      alt="Icon"
                      className="cell-icon"
                      data-tooltip-id="tt-calendar-patient"
                    ></img>
                    <TooltipBox
                      id="tt-calendar-patient"
                      content={
                        <div className="cell">Último paciente consultado</div>
                      }
                    ></TooltipBox>
                  </button>
                </div>
                <div className="calendar-day-events-lists">
                  {eventsPopupEventsFuture && (
                    <PopupEventsPatientList
                      title="Citas futuras"
                      events={eventsPopupEventsFuture}
                      onClickEvent={(event) => clickEvent(event)}
                    />
                  )}
                  {eventsPopupEventsPast && (
                    <PopupEventsPatientList
                      title="Citas pasadas"
                      events={eventsPopupEventsPast}
                      onClickEvent={(event) => clickEvent(event)}
                    />
                  )}
                </div>
              </div>
              <div className="popup-row-buttons-container">
                <div className="popup-row-buttons">
                  <ButtonIconH
                    text="Cerrar"
                    onClick={() => openEventsPopup(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {editEvent && (
        <PopupEvent
          event={editEvent}
          onSave={onSaveEvent}
          onCancel={closeEventPopup}
          onDelete={onDeleteEvent}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
    </div>
  );
}
